
import { LabMDM } from '../masterdata/models/lab';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { Component, OnInit, Input } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { SelectableLab } from '../carrier/selectable-lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';

@Component({
  selector: 'app-mdm-processflow',
  templateUrl: './mdm-processflow.component.html',
  styleUrls: ['./mdm-processflow.component.css']
})
export class MdmProcessflowComponent implements OnInit {

  @Input() masterLists: ProcessFlow[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading: boolean;

  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: ProcessFlow;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: ProcessFlow;
  selectedLabName: string;
  selectedLab: LabMDM;
  uploadedFile: any;
  disableDownloadTagsButton: boolean = true;
  disableDownloadPlateButton: boolean = true;
  uploadedFileName: string;
  blocked: boolean = false;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private apgTestingService: APGTestingService) { }

  ngOnInit() {
    this.getActiveOptionsForDropdowns();
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new ProcessFlow;
    this.setFalseToNullProcessFlowProperties();
    this.uploadedFile = null;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.uploadedFileName = "";
  }

  setFalseToNullProcessFlowProperties(){
    this.tableCols.forEach(col => {
      if(["Reception","Preparation", "SampleFlow"].includes(col.group) && this.masterList[col.field]==null)
        this.masterList[col.field] = false;
    })
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    event.data['aliqoutVolume'] = (Number(event.data['aliqoutVolume'])>=0 && event.data['aliqoutVolume']!="") || event.data['aliqoutVolume']!="" ?  event.data['aliqoutVolume']: "10"
    this.masterList = this.cloneMasterList(event.data);
    this.setFalseToNullProcessFlowProperties()
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }

  getActiveOptionsForDropdowns(): any {
    this.labOption = [];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {

          if (lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions = this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.processFlowName && this.selectedLab);
  }
  private handleError(error: any) {
    this.blocked = false
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }

  saveMasterList() {
    if (!this.masterLists || this.masterLists == null) {
      let processFlowArray: ProcessFlow[] = [];
      this.masterLists = processFlowArray;
      this.saveMasterData(processFlowArray);
    }
    else {
      let masterLists = [...this.masterLists];
      if (this.isNewMasterList) {
        this.saveMasterData(masterLists);
      }
      else {
        this.updateMasterData(masterLists);
      }
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;

    this.blocked = true;
    this.appendHistory("processFlow");
    this._masterDataService.saveConfig(this.selectedLab, this.masterList, "processFlow").subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this.blocked = false
      },
      error => {
        this.handleError(error);
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.blocked = true;
    this.appendHistory("processFlow");
    this._masterDataService.updateConfig(this.selectedLab, this.masterList, "processFlow").subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterLists.forEach(function(processFlow, index){
          this.masterLists[index]['aliqoutVolume'] = (Number(this.masterLists[index]['aliqoutVolume'])>=0 && this.masterLists[index]['aliqoutVolume']!="") || this.masterLists[index]['aliqoutVolume']!="" ?  this.masterLists[index]['aliqoutVolume']: "10"
        }, this)

        this.masterList = null;
        this.displayMasterListDialog = false;
        this.blocked = false
      },
      error => {
        this.handleError(error);
      }
    );
  }


  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  appendHistory(tabName: string) {
    let historyObj: OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if (this.masterList.history) {
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
  
  disableProcessFlowNameField(){
    return this.masterList._id ? true : false;
  }
}
